import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class BadgeService {

    constructor(private http: HttpClient) { }

    getBadges(wallet: string): Observable<IbadgeResponse> {
        return this.http.post<IbadgeResponse>(environment.apiBaseUrl + 'internal/getHuntBadge.php', { address: wallet });
    }

    retrieveTrainerInviteLink(invite_uiid: string): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'auth/retrieveTrainerInviteLink.php', { signature_uuid: invite_uiid });
    }

    createInviteTrainer(signature_uiid: string, wallet: string): Observable<any> {
        return this.http.post(environment.apiBaseUrl + 'auth/createTrainerInviteLink.php', { secret: signature_uiid, walletId: wallet });
    }
}


export interface IbadgeResponse {
    status_supporter: boolean
    status_hunt: boolean
}